module.exports = __webpack_public_path__ + "img/mono_31.5f8ef39a.png";